<app-mixer-sidebar #sidebar [is_fullscreen]="is_fullscreen" cdkScrollable (addOperation)="addOperation($event)"
  (addDraft)="addDraftClicked()" (createNote)="createNewNote()">
</app-mixer-sidebar>


<app-palette id="scrollable-container" class="palette mode-{{palette.cur_mixer_mode}}"
  [class.no-pointer]="!palette.pointer_events" [class.shift-held]="palette.shift_held"
  [class.space-held]="palette.space_held" [class.middle-mouse-held]="palette.middle_mouse_held" #palette
  (onOpenInEditor)="openDraftInEditor($event)" (onPerformOperationError)="postOperationErrorMessage($event)">
</app-palette>